export default __webpack_public_path__ + "static/media/list.658d0f85.svg";